import React from 'react';
import { observer } from 'mobx-react';
import { FacilityInventoryCountEditTemplate } from 'themes/application/facility-inventory/pages';
import { setCurrentView } from 'core/utils';
import { FacilityInventoryCountEditViewStore } from 'application/facility-inventory/stores';

@setCurrentView((rootStore) => new FacilityInventoryCountEditViewStore(rootStore), "facilityInventoryCountEditViewStore")
@observer
class FacilityInventoryCountEdit extends React.Component {
    render() {
        return <FacilityInventoryCountEditTemplate {...this.props} />
    }
}

export default FacilityInventoryCountEdit;